import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Label } from "ui/components/label";
import { useNavigate } from "react-router-dom";
import SelectStatus from "components/select/status";
import { currenciesSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useCurrencyForm } from "./useCurrencyForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";

const CurrencyForm = ({ currencyId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useCurrencyForm({
    currencyId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={currencyId || "+"}
      schema={currenciesSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Name Field */}
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="currencies"
                  type="form"
                >
                  <FormLabel required>Name</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* INR */}
          <FormField
            control={form.control}
            name="budget_rate_inr"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="currencies"
                  type="form"
                >
                  <FormLabel>INR value</FormLabel>
                  <Input
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    value={field.value ?? ""}
                    onChange={(e) =>
                      field.onChange(
                        e.target.value === ""
                          ? undefined
                          : parseFloat(e.target.value),
                      )
                    }
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* USD */}
          <FormField
            control={form.control}
            name="budget_rate_usd"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="currencies"
                  type="form"
                >
                  <FormLabel>USD value</FormLabel>
                  <Input
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    value={field.value ?? ""}
                    onChange={(e) =>
                      field.onChange(
                        e.target.value === ""
                          ? undefined
                          : parseFloat(e.target.value),
                      )
                    }
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Status */}
          <FormField
            control={form.control}
            name="status"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="currencies"
                  type="form"
                >
                  <FormLabel>Status</FormLabel>
                  <SelectStatus
                    collection="currencies"
                    onValueChange={(val) => field.onChange(val)}
                    {...field}
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="currencies"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default CurrencyForm;
